import TableDrivers from '../../components/drivers/TableDrivers'
import { connect } from 'react-redux'
import { actionCreators } from '../../state/actions/drivers/index'
import { restoreFromArchive, archiveDriver, getDriversList } from '../../state/actions/drivers/'
import { IStoreState, IDriverFilters, IDriverSearchObject } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  return {
    ownProps,
    currentOrganizationId: state.organizations.currentOrgId,
    showDrivers: state.drivers.showDrivers,
    drivers: Object.values(state.drivers.items),
    isFetching: state.drivers.itemsRequest,
    error: state.drivers.itemsError,
    isDriverStatusChanging: state.drivers.isChangeStatusRequesting,
    totalDrivers: state.drivers.totalDrivers,
    filters: state.drivers.filters
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getDriversList: (filters: IDriverFilters) => dispatch(getDriversList(filters)),
    archiveDriver: (driver: IDriverSearchObject) => dispatch(archiveDriver(driver)),
    restoreDriver: (driver: IDriverSearchObject) => dispatch(restoreFromArchive(driver)),
    updateDriverFilters: (params: IDriverFilters) => dispatch(actionCreators.updateDriverFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableDrivers)



// WEBPACK FOOTER //
// ./src/containers/drivers/TableDrivers.ts